import parse from 'date-fns/parse';
import format from 'date-fns/format';
import add from 'date-fns/add';

const MILESTONES = [14, 16, 32, 60, 70, 120, 150, 210, 270, 300, 340];

let dates = [];

const controller = document.querySelector(
	'[data-controller="foaling-calculator"]'
);

const targets = Array.from(
	controller?.querySelectorAll('[data-target]') ?? []
).reduce(
	(targets, target) => ({
		...targets,
		[target.dataset.target]: target,
	}),
	{}
);

targets.form.addEventListener('submit', async (event) => {
	event.preventDefault();
	const formData = new FormData(event.target);
	const ovulationDate = parse(
		formData.get('ovulation_date'),
		'yyyy-MM-dd',
		new Date()
	);
	formData.set('ovulation_date', format(ovulationDate, 'MM/dd/yyyy'));
	formData.append('action', 'handle_foaling_calculator_submission');
	document.querySelector('#foaling-calculator-error')?.remove();
	targets.sendEmail.disabled = true;

	try {
		const response = await fetch('/wordpress/wp-admin/admin-ajax.php', {
			method: 'POST',
			body: formData,
		});

		if (response.ok) {
			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.style.display = 'none';
			a.href = url;
			a.download = 'foaling_calculator_data.xlsx';
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(url);
			targets.emailField.outerHTML = `
<div class="alert alert-success not-prose" role="alert" style="max-width: 768px;">
	<p>Thank you for using our foaling calculator! Your form should have downloaded.</p>
</div>
			`;
		} else {
			event.target.querySelector('button[type="submit"]').disabled =
				false;

			const message = await response.json();
			targets.emailField.insertAdjacentHTML(
				'beforeend',
				`
<div class="alert alert-error col-span-full not-prose" id="foaling-calculator-error" role="alert">
	<p>${message.data}</p>
</div>
				`
			);
		}
	} catch (error) {
		console.error('Error:', error);
	}
});

targets.ovulationDate.addEventListener('change', (event) => {
	targets.submit.disabled = !event.target.value;
});

targets.emailField
	.querySelector('input')
	.addEventListener('change', (event) => {
		targets.sendEmail.disabled = !event.target.value;
	});

targets.submit.addEventListener('click', () => {
	toggleResults(false);
	applyDates();
});

function applyDates() {
	const ovulationDate = parse(
		targets.ovulationDate.value,
		'yyyy-MM-dd',
		new Date()
	);

	dates = calculateFoalingDatesFrom(ovulationDate);

	targets.resultsWrapper
		.querySelectorAll('[data-result-field]')
		.forEach((el, index) => {
			el.value = format(dates[index], 'MM/dd/yyyy');
		});

	toggleResults(true);
	scrollToResults();
}

function toggleResults(isVisible) {
	targets.resultsWrapper.classList.toggle('hidden', !isVisible);
	// targets.resultsWrapper.querySelector('button[type="submit"]').disabled =
	// 	!isVisible;
}

function scrollToResults() {
	const rect = targets.resultsWrapper.getBoundingClientRect();
	const scrollTop = document.documentElement.scrollTop;
	const distanceToTop = rect.top + scrollTop;

	window.scrollTo({
		top: distanceToTop - _getTopMargin(),
		behavior: 'smooth',
	});
}

function calculateFoalingDatesFrom(date) {
	return MILESTONES.map((days) => add(date, { days }));
}

function _getTopMargin() {
	const adminBar = document.getElementById('wpadminbar');
	const header = document.querySelector('header.site-header');
	return (adminBar?.clientHeight ?? 0) + header.clientHeight + 16;
}
